import { render, staticRenderFns } from "./comment-modify.vue?vue&type=template&id=66013ade&scoped=true"
import script from "./comment-modify.vue?vue&type=script&lang=ts"
export * from "./comment-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66013ade",
  null
  
)

export default component.exports